module.exports = "/img/_/_/_/assets/images/avatar/portrait/male//rogue.png?183b3a7b92f9e38f2df361853b7757f3";